// Singleton CallEngine, constructed OUTSIDE the React tree (SPEC §9.3.1).
// Components pull tracks/levels from it imperatively; its events flow into
// the Zustand store via bindEngineToStore (store/callStore.ts).

import { CallEngine, silenceSdkLogsInProd } from '@brizina/call-engine';
// Frame crypto runs in the SDK's E2EE worker (§5.1); vite bundles it.
import E2EEWorker from 'livekit-client/e2ee-worker?worker';

silenceSdkLogsInProd(import.meta.env.PROD);

export const engine = new CallEngine({
  storage: window.localStorage,
  createE2EEWorker: () => new E2EEWorker(),
});
